import React from "react";
import { STAFF_SCHEDULE_DAYS, staffScheduleRoleShort } from "./staffScheduleConstants";
import { formatTimeRange12, slotForDay } from "./staffScheduleTime";

const StaffSchedulePrintSheet = ({ patient, rows }) => {
  const patientName = [
    patient?.firstName,
    patient?.middleName,
    patient?.lastName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="staff-schedule-print-sheet mx-auto max-w-[1000px] bg-white text-slate-900 p-8 print:p-6">
      <header className="border-b-2 border-indigo-800 pb-4 mb-6">
        <p className="text-[10px] font-bold uppercase tracking-widest text-indigo-600">
          Patient Staff Schedule
        </p>
        <h1 className="text-xl font-bold text-slate-900 mt-1">{patientName}</h1>
        <div className="flex flex-wrap gap-x-6 gap-y-1 mt-2 text-xs text-slate-600">
          {patient?.mrn ? <span>MRN: {patient.mrn}</span> : null}
          {patient?.patientNumber ? (
            <span>Patient #: {patient.patientNumber}</span>
          ) : null}
        </div>
        <p className="text-[11px] text-slate-500 mt-2">
          Recurring weekly schedule — assigned care team only
        </p>
      </header>

      {!rows?.length ? (
        <p className="text-sm text-slate-500 italic py-8 text-center">
          No assigned staff or schedule times on file.
        </p>
      ) : (
        <table className="w-full border-collapse text-[11px]">
          <thead>
            <tr className="bg-indigo-50">
              <th className="border border-indigo-200 px-2 py-2 text-left font-bold text-indigo-900">
                Staff Name
              </th>
              <th className="border border-indigo-200 px-2 py-2 text-left font-bold text-indigo-900">
                Position
              </th>
              {STAFF_SCHEDULE_DAYS.map((day) => (
                <th
                  key={day.value}
                  className="border border-indigo-200 px-1 py-2 text-center font-bold text-indigo-900"
                >
                  {day.short}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.assignmentId}>
                <td className="border border-slate-200 px-2 py-2 font-semibold">
                  {row.firstName} {row.lastName}
                </td>
                <td className="border border-slate-200 px-2 py-2 text-center">
                  <span className="inline-block rounded border border-indigo-200 bg-indigo-50 px-1.5 py-0.5 text-[10px] font-bold uppercase text-indigo-800">
                    {staffScheduleRoleShort(row.role)}
                  </span>
                </td>
                {STAFF_SCHEDULE_DAYS.map((day) => {
                  const slot = slotForDay(row.slots, day.value);
                  return (
                    <td
                      key={day.value}
                      className="border border-slate-200 px-1 py-2 text-center align-top"
                    >
                      {slot ? (
                        <div>
                          <div className="font-medium tabular-nums">
                            {formatTimeRange12(slot.startTime, slot.endTime)}
                          </div>
                          {slot.breakStartTime && slot.breakEndTime ? (
                            <div className="text-[9px] text-slate-500 mt-0.5">
                              Break:{" "}
                              {formatTimeRange12(
                                slot.breakStartTime,
                                slot.breakEndTime,
                              )}
                            </div>
                          ) : null}
                          {slot.notes ? (
                            <div className="text-[9px] text-slate-500 mt-0.5 italic">
                              {slot.notes}
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <span className="text-slate-300">—</span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <footer className="mt-8 pt-4 border-t border-slate-200 text-[10px] text-slate-400 text-center">
        Printed from Kornivus Home Health EMR · Staff Assignment
      </footer>
    </div>
  );
};

export default StaffSchedulePrintSheet;
